import { Component, OnInit, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { InputComponent } from '../input/input.component';
import { SLLayer } from 'src/app/model/sl-layer';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';

import { StorageService } from 'src/app/model/api-services/storage-services.service';
import { CastingMediaValue } from 'src/app/components/att-casting-view/formats/casting-media-sel/casting-media-sel.component';
import { FileResource } from 'src/app/model/file-resource';

import { NumberQualifierService } from 'src/app/model/api-services/qualifiers/number-qualifier.service';
import { Lightbox } from 'ngx-lightbox';
import { MediaQualifierService, MediaQualifierVal } from 'src/app/model/api-services/qualifiers/MediaQualifier.service';
import { SL_ID_PREFIX, SlIdContext } from 'src/app/model/directives/sl-id-context';

@Component({
  selector: 'app-media-input',
  templateUrl: './media-input.component.html',
  styleUrls: ['./media-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    SlIdContext,
    {
      provide: SL_ID_PREFIX,
      useValue: 'attr-media-input'
    }
  ],
})
export class MediaInputComponent extends InputComponent implements OnInit {

  public allowPhoto = false;
  public allowFile = false;
  public mediaValue: CastingMediaValue;
  public fileInfo: FileResource;
  private album: Array<any> = [];
  public hasURL = false;
  public get fileSelected(): boolean {
    if (!this.currentValue || !this.currentValue.fileName) {
      return false;
    }
    return true;
  }
  public set currentValue(val: any) {
    super.currentValue = val;
    if (!!val && !!val.data && val.fileName) {
      this.album.splice(0, 1);
      this.album.push({
        src: this.dataURL,
        caption: this.fileName
      })
      this.cdr.detectChanges();
      return;
    }
    if ([null, '', undefined].indexOf(val) > -1) {
      this.cdr.detectChanges();
      return;
    }
    if ((typeof val === 'string') && (val.indexOf('https://') > -1)) {
      super.currentValue = MediaQualifierService.FromString(val);
      this.album.splice(0, 1);
      this.album.push({
        src: MediaQualifierService.ToString(this.GetSuperValue()),
        caption: (super.GetSuperValue() as MediaQualifierVal).fileName
      })
      this.cdr.detectChanges();
      return;
    }
    if (!this.album.length) {
      if (!!val.url && !!val.fileName) {
        this.album.push({ src: val.url, caption: val.fileName })
        this.cdr.detectChanges();
        return;
      }
    }


  }

  public get currentValue(): any {
    return super.GetSuperValue();
  }
  public get hasImage(): boolean {
    return this.album.length > 0;
  }
  constructor(
    private domNode: ElementRef, private storageSvc: StorageService,
    private lb: Lightbox, protected cdr: ChangeDetectorRef) {
    super(cdr);
    this._domNode = this.domNode;

  }
  ShowImage() {
    if (!this.currentValue || !this.currentValue.fileName) {
      return;
    }
    if (this.album.length === 0) return;
    this.lb.open(this.album, 0);
  }
  get fileName() {
    if (!this.currentValue || !this.currentValue.fileName) {
      return '';
    }
    return this.currentValue.fileName;
  }
  get fileSize() {
    if (!this.currentValue || !this.currentValue.size) {
      return '';
    }
    return this.currentValue.size;
  }
  get fileSizePretty() {
    if (!this.currentValue || !this.currentValue.size) {
      return '';
    }
    return NumberQualifierService.ToString(this.currentValue.size, 'comma-dot', 0) + ' Bytes';
  }
  get dataURL(): string {
    if (!this.currentValue || !this.currentValue.data) {
      return '/assets/images/empty.png';
    } else {
      return `data:${this.currentValue.mimeType};base64,${this.currentValue.data}`;
    }
  }
  SetAttribute(layer: SLLayer, attribute: AttributeInfo) {
    super.SetAttribute(layer, attribute);
    this.allowPhoto = false;
    this.allowFile = false;
    if (attribute.casting && attribute.casting.entry && attribute.casting.entry.mediaValue) {
      this.mediaValue = attribute.casting.entry.mediaValue;
      switch (this.mediaValue.mediaOption) {
        case 'any':
          this.allowPhoto = true;
          this.allowFile = true;
          break;
        case 'file':
          this.allowFile = true;
          break;
        case 'photo':
          this.allowPhoto = true;
          break;
      }
    }
    this.currentValue = this.currentValue;
  }

  Reset() {
    super.Reset();

  }

  FileSelected(type: 'file' | 'image', event) {
    const me = this;
    const file = event.target.files[0];
    this.fileInfo = new FileResource(file, () => {
      this.currentValue = {
        fileName: this.fileInfo.fileName,
        size: this.fileInfo.fileSize,
        mimeType: this.fileInfo.mimeType,
        data: this.fileInfo.data
      }
      this.domNode.nativeElement.classList.toggle('disabled', false);
      this.cdr.detectChanges();
    });
    this.domNode.nativeElement.classList.toggle('disabled', true);

  }

  ngOnInit(): void {
    super.ngOnInit();
  }
  Update(val: string) {
    this.currentValue = val;
    this.cdr.detectChanges();

  }

}
